import type { SVGProps } from "react"

/**
 * O simbolo "D" da DIMPET, em traçado unico.
 *
 * Usado como marca d'agua sobre fundo verde. O prototipo repetia este path
 * inteiro — 200 caracteres de coordenadas — em duas secoes diferentes.
 */
export function BrandSymbol({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 810 810" fill="none" className={className} aria-hidden="true" {...rest}>
      <path
        d="M119 91 L119 101 C145 97 183 136 183 176 L183 438 C211 453 224 467 243 505 L243 141 L448 141 C723 149 789 615 448 693 C366 707 304 687 261 631 C253 520 214 473 82 420 C73 587 153 641 255 684 L303 701 C222 653 188 590 131 505 C191 543 235 639 293 684 C382 735 500 721 542 701 C654 648 729 537 729 412 C729 225 616 109 456 93 Z"
        fill="currentColor"
      />
    </svg>
  )
}
